










import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class MyCourse extends Vue {
  @Prop({ default: [] }) tags: string[] // tags数据
  @Prop() align: string

  async mounted() {
    if (this.tags && this.tags.length > 0) {
      let tagEl = this.$refs['tags'] as HTMLElement
      if (tagEl) {
        let outerW = tagEl.offsetWidth
        let childs = [...tagEl.childNodes]
        let c1 = (childs[0] as HTMLElement).offsetWidth
        let c2 = childs[1] ? (childs[1] as HTMLElement).offsetWidth : 0

        let childW = c1 + c2
        if (childs.length === 3) {
          if (childW + 15 - outerW > 0) {
            childs[2].remove()
          }
        }
      }
    }
  }
}
